import styled, { css } from "styled-components";
import { fonts } from "@tvg/design-system/src/theming/themes/common/fonts";

interface StatusValueProps {
  perfectStatus?: boolean;
}

export const PastPerformanceStats = styled.div`
  background-color: ${({ theme }) => theme.colorTokens.content.onDark};
`;

export const IppStatsMaskContainer = styled.div`
  width: 100%;
  margin-left: -12px;
`;

export const Title = styled.h3`
  line-height: 22px;
  font-size: 16px;
  font-family: ${fonts.bold};
`;

export const Status = styled.ul`
  display: flex;
  justify-content: left;
  align-items: center;
  color: ${({ theme }) => theme.colorTokens.content.subtle};
`;

export const StatusItem = styled.li`
  position: relative;
  display: flex;
  align-items: baseline;
  line-height: 20px;
  margin-left: 8px;
  padding-right: 9px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    &::after {
      display: none;
    }
  }

  &::after {
    content: "";
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 12px;
    background-color: ${({ theme }) => theme.colorTokens.background.neutral};
  }
`;

export const StatusKey = styled.span`
  font-family: ${fonts.condensedRegular};
  text-transform: uppercase;
`;

export const StatusValue = styled.span<StatusValueProps>`
  margin-left: 4px;
  font-family: ${fonts.medium};
  ${(props) =>
    props.perfectStatus &&
    css`
      color: ${({ theme }) =>
        theme.colorTokens.component.button.betting.background.base};
    `};
`;
